module.exports = __webpack_public_path__ + "img/en_Ecran 1.87169d11.png";